<template>
  <div class="row task-container">
    <div class="col-md-12">
      <template>
        <button  @click="refresh()" class="btn btn-primary">
          <div class="loader small_loader" v-if="loading"></div>
          <span v-else><i class="fa fa-refresh"></i> Refresh</span>
        </button>
        <br/><br/>
      </template>
      <table class="table table-striped task-table" :id="tableId" v-if="tasks.length">
        <thead>
        <tr>
          <th>Username</th>
          <th class="text-center">Acknowledge By</th>
          <th class="text-center">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row,index) in tasks" :key="'queueTask_' + index">
          <td>{{row.user}}</td>
          <td class="text-center">
             <span v-if="row.checkIn" class="badge badge-pill badge-success">
              {{row.checkIn}}
            </span>
          </td>
          <td class="text-center">
            <section v-if="row.checkIn">
              <button :disabled="loading === 'login' && resolvingIndex === index" class="btn btn-success btn-sm mr-2"  @click="handleClick(row, index, 'login')">
                <div class="loader mini_loader" v-if="loading === 'login' && resolvingIndex === index"></div>
                <span v-else>Login</span>
              </button>
              <button :disabled="loading === 'resolve' && resolvingIndex === index" class="btn btn-primary btn-sm mr-2" @click="handleClick(row, index, 'resolve')">
                <div class="loader mini_loader" v-if="loading === 'resolve' && resolvingIndex === index"></div>
                <span v-else> Resolve</span>
              </button>
              <button :disabled="loading === 'terminate' && resolvingIndex === index" class="btn btn-danger btn-sm mr-2" @click="handleClick(row, index, 'terminate')">
                <div class="loader mini_loader" v-if="loading === 'terminate' && resolvingIndex === index"></div>
                <span v-else>Terminate</span>
              </button>
            </section>
            <section v-else>
              <button :disabled="loading === 'checkin' && resolvingIndex === index" class="btn btn-primary btn-sm mr-2" @click="handleClick(row, index, 'checkin')">
                <div class="loader mini_loader" v-if="loading === 'checkin' && resolvingIndex === index"></div>
                <span v-else>Check In</span>
              </button>
            </section>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import supportTaskMixin from "@/mixins/supportTaskMixin";

export default {
  name: "notInWPO",
  mixins: [supportTaskMixin],
  props: {
    tasks: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true
    },
    tableId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      resolvingIndex: -1
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  mounted () {
    if (this.tableId) {
  $(`#${this.tableId}`).DataTable({
    pagingType: "full_numbers",
    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
    destroy: true,
    retrieve: true,
    deferRender: true,
    "ordering": false,
    stateSave: true,
    language: {
      search: "_INPUT_",
      searchPlaceholder: "Search Task",
      size: 50
    }
  });
  }},
  methods: {
    async login (row) {
      try {
        console.log('in login')
        let resp = await this.$http.post('email/create_user_session',{
          grant_type:'token',
          username: row.user
        });
        console.log(resp.data);
        window.open(resp.data.data.url, '_blank');
      } catch (e) {
        console.log('Error in login')
        swal({
          title: "Error",
          text: 'Something went wrong while logging in to cpanel',
          type: "error"
        })
      }
    },
    async resolve (row) {
      console.log('in resolve')
      try{
        const userRef = await db.collection('users').where('emailUsernames.username', '==', row.user).get();
        if(userRef.size){
          await db.collection('NotInWPO_CP').doc(row.id).delete()
          await db.collection('bigScootsTasks').add({
            createdAt: new Date().toISOString(),
            status: 'resolved',
            type: 'support',
            text: 'Cpanel Account',
            email: row.user,
            domain: row.user,
            resolvedAt: new Date().toISOString(),
            resolvedBy: this.user.firstName + ' ' + this.user.lastName
          });
          swal({
            title: "Success",
            text: 'You have successfully resolved this support task!',
            type: "success"
          })
          // await this.$emit('updateData')
          return true
        }
        swal({
          title: "Success",
          text: 'WPO does not have this user so we cannot resolve it!',
          type: "success"
        })
        return true
      } catch (e) {
        swal({
          title: "Error",
          text: 'Something went wrong while resolving! ',
          type: "danger"
        })
      }
    },
    async terminate (row) {
      console.log('in terminate')
      try {
        swal({
          title: "Are you sure?",
          text: "Are you sure that you want to terminate this Account?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
            .then( async result => {
              if (result.value) {
                const resp = await this.$http.post('email/remove-account',{
                  grant_type:'token',
                  username: row.user
                });
                console.log(resp.data);
                await db.collection('NotInWPO_CP').doc(row.id).delete()
                // await this.$emit('updateData')
                swal({
                  title: "Success",
                  text: 'You have successfully terminated this cpanel user',
                  type: "success"
                })
              }
            })
      } catch (e) {
        console.log('Error in terminating')
        swal({
          title: "Error",
          text: 'Something went wrong while terminating user',
          type: "error"
        })
      }
    },
    async checkin (row) {
      try {
        await db.collection('NotInWPO_CP').doc(row.id).update({
          checkIn: this.user.firstName + ' ' + this.user.lastName,
          checkedAt: new Date().toISOString()
        })
        // await this.$emit('updateData')
      } catch (e) {
        console.log('Error in Check In')
        swal({
          title: "Error",
          text: 'Something went wrong while check in',
          type: "error"
        })
      }
    },
    async handleClick (row, index, type) {
      this.resolvingIndex = index
      this.loading = type
      switch (type) {
        case 'login':
          await this.login(row)
          break;
        case 'terminate':
          await this.terminate(row)
          break;
        case 'resolve':
          await this.resolve(row)
          break
        case 'checkin':
          await this.checkin(row)
          break
        default:
          break
      }
      this.resolvingIndex = -1
      this.loading = false
    },
    async refresh(){
      try{
        this.loading=true;
        let resp = await this.$http.post('email/update-extra-cpanel-accounts-list',{
          grant_type:'token',
        });
        console.log(resp.data);
        // await this.$emit('updateData')
        swal({
          title: "Success",
          text: resp.data.msg,
          type: "success"
        })
      }
      catch (e) {
        swal({
          title: "Error",
          text: 'Something went wrong while refreshing data!',
          type: "error"
        })
      }finally {
        this.loading=false
      }
    },
  }
}
</script>

<style scoped lang="scss">
.task-container{
  padding: 1.5em;
}
.cf-status-icons {
  i {
    font-size: 25px;

    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
  }
}
.click-to-copy{
  margin: 0 !important;
  padding: 7px !important;
}
</style>
